export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    time: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '0'
    },
    left: {
      type: String,
      default: '0'
    },
    versionId: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  mounted() {
    this.isShow = this.show;
  },
  methods: {
    prompt() {
      window.localStorage.setItem('SYS_VERSION_PROMPT', this.versionId);
      this.isShow = !this.isShow;
    }
  }
};